var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.$style.introductionContainer,attrs:{"data-luko-tracking":"Introduction"}},[_c('RichText',{attrs:{"text-params":_vm.primary.text}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }